import { Controller } from 'stimulus';
import MitreTable from '../utils/mitre-table';

class CheckboxListFilter extends Controller {
  static targets = [
    'checkboxListSelector',
    'checkboxListContainer',
    'checkboxListButton',
    'checkboxInputContainer',
    'checkboxInputLabel',
    'checkboxInput'
  ];

  static values = {
    key: String,
    type: String,
    selections: String
  };

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    this.filterKey = this.keyValue;
    this.filterType = this.typeValue;
    this.filterSelections = this.selectionsValue ? JSON.parse(this.selectionsValue) : {};
    this.triggerDefaultSelections = true;
    this.__setDefaultSelectedValues();
  }

  connect() {

    this._mitreTable.on('reset_filters', () => {
      this.checkboxInputTargets.forEach((el) => {
        el.removeAttribute('checked');
        this.__setButtonState(false);
      })
    });
  }

  updateFilter(e) {
    e.preventDefault();

    const { filters } = this._mitreTable.getParams();

    let inputSelection = e.target.firstElementChild;
    if (inputSelection) {
      let listValues = [];

      if(filters) {
        const currentValues = filters[this.filterKey];

        if(currentValues) {
          listValues = currentValues.value;
          const itemIdx = listValues.indexOf(inputSelection.value);

          if(itemIdx > -1) {
            listValues.splice(itemIdx, 1);
            inputSelection.removeAttribute('checked');
          } else {
            listValues.push(inputSelection.value);
            inputSelection.setAttribute('checked', true);
          }
        } else {
          listValues.push(inputSelection.value);
          inputSelection.setAttribute('checked', true);
        }
      } else {
        listValues.push(inputSelection.value);
        inputSelection.setAttribute('checked', true);
      }

      this.__setButtonState(listValues.length > 0);

      EventManager.emit('update_filter', {
        filterKey: this.filterKey,
        selected: false,
        value: listValues,
        type: this.filterType
      });
    }
  }

  closeState() {
    setTimeout(() => {
      let hideSelector = true;
      let selectors = ['checkboxListSelector', 'checkboxInputContainer', 'checkboxInputLabel', 'checkboxInput'];

      for(let selector of selectors) {
        if(this.element.querySelector(`[data-checkbox-list-filter-target="${selector}"]`) === document.activeElement) {
          hideSelector = false;
          break;
        }
      }

      if (!this.checkboxListSelectorTarget.classList.contains('t-hidden') && hideSelector) {
        this.checkboxListSelectorTarget.classList.add('t-hidden');
      }
    }, 10);
  }

  popupStatus(e) {
    e.stopPropagation();

    if (this.checkboxListSelectorTarget.classList.contains('t-hidden')) {
      if (this.triggerDefaultSelections) {
        this.__setDefaultSelectedValues();
      }
      this.checkboxListSelectorTarget.classList.remove('t-hidden');
    } else {
      this.checkboxListSelectorTarget.classList.add('t-hidden');
    }

    EventManager.emit('scroll_container', {
      selector: this.checkboxListSelectorTarget,
      container: this.checkboxListContainerTarget
    });
  }

  __setDefaultSelectedValues() {
    const { defaultFilters } = this._mitreTable.getParams();
    let mappingDefaultFilters = {};

    defaultFilters.forEach((val, idx) => {
      if (this.filterKey === val['filterType']) {
        mappingDefaultFilters[this.filterKey] = this.__defaultFilterHandler(mappingDefaultFilters[this.filterKey], val['value']);

        defaultFilters.splice(idx, 1);
        const valTemp = defaultFilters.length > 0 ? defaultFilters : '[]'
        document.querySelector('[data-default-filters]').setAttribute('data-default-filters', valTemp);
      }
    });

    if(mappingDefaultFilters[this.filterKey]) {
      this.__setButtonState(true);

      this._mitreTable.emit('apply_default_filter', { // listeners: filter_controller.js
        filterKey: this.filterKey,
        selected: false,
        value: mappingDefaultFilters[this.filterKey],
        type: this.filterType
      });
    }
    this.triggerDefaultSelections = false;
  }

  __setButtonState(state) {
    EventManager.emit('filter_button_state', { element: this.checkboxListButtonTarget, state: state })
  }

  __defaultFilterHandler(initArr, val) {
    let result;

    if (initArr) {
      result = initArr.concat(val);
    } else {
      result = val
    }

    val.forEach((el) => {
      document.getElementById(`${this.filterKey}_${el}`).setAttribute('checked', true);
    })

    return result;
  }
}

export default CheckboxListFilter;
